import { PermissionCategory } from '../../enums';

export interface CorporatePermissionDto {
  id: string; // Guid
  name: string;
  description?: string | null;
  category: PermissionCategory;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
}
